import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import MainMap from '../components/MainMap';
import PersonalisedReqs from '../components/PersonalisedReqs';
import SimilarReqs from '../components/SimilarReqs';
import UpiriaModal from '../components/UpiriaModal'; // Ensure this path is correct
import PopularDestinationsHome from '../components/home/PopularDestinationsHome';

const Container = styled.div`
  margin-bottom: 10px;
`;

const RecomendationsContainer = styled.div`
  display:flex;
  flex-direction: column;
  margin: 0px 100px 100px;

  @media (max-width: 768px) {
    margin-bottom: 80px;
    margin: 50px;
    text-align:center;
    align-items:center;
  }
`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 10px;

    @media (max-width: 768px) {
     font-size: 25px;
    }
`;

const Description = styled.div`
   font-size: 15px;
   margin-bottom: 50px;
   color:#91abb3;

   @media (max-width: 768px) {
    font-size: 10px;
   }
`;

const FloatingBookButton = styled.button`
  position: fixed; /* Fixed on viewport */
  bottom: 30px;    /* Distance from bottom */
  right: 60px;     /* Distance from right */
  z-index: 99999;  /* Always above map */
  background: #e55a5c;
  color: #fff;
  text-align: center;
  cursor: pointer;
  border-radius: 0.375rem;
  padding: 0.8rem 1.5rem; /* Smaller padding on mobile */
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.05rem;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  border: none;
  white-space: nowrap;

  &:hover {
    background: #c94b4d;
  }

  @media (max-width: 768px) {
    bottom: 15px;
    right: 30px;
    // padding: 0.6rem 1.2rem;
    // font-size: 0.75rem;
  }

  @media (max-width: 480px) {
    bottom: 50px;
    right: 30px;
    // padding: 0.5rem 1rem;
    // font-size: 0.7rem;
  }
`;

const PlanYourTrip = () => {
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const loggedIn = sessionStorage.getItem("loggedIn");
  // const userRole = sessionStorage.getItem("userType");

  // Hardcoded link and title
  const standardUpiriaLink = "https://app.upiria.com/experiences/0f72e7f9-4747-4d0a-9eca-d4939c8beb41";
  const standardExpTitle = "Olympus Experience";
  const userRole = sessionStorage.getItem("userRole");
  const [showBookingModal, setShowBookingModal] = useState(false);

  return (
    <Container>
      <MainMap />

      {loggedIn && userRole == "RegisteredUser" && (
        <RecomendationsContainer>
          <Title> {i18n.t('suggestions')}</Title>
          <Description>
            {selectedLanguage === 'gr' ? (
              <>
               Ως εγγεγραμμένος χρήστης της εφαρμογής Olympus Riviera Greece, θέλω να λαμβάνω προτάσεις
               δραστηριοτήτων ή σημείων ενδιαφέροντος που να βασίζονται είτε στις αξιολογήσεις και τις προτιμήσεις
               χρηστών με παρόμοιο προφίλ (Collaborative Filtering) είτε στις δικές μου προηγούμενες προτιμήσεις και
               επιλογές μου (Content-based Filtering), ώστε να βρω προτάσεις που ταιριάζουν με τα ενδιαφέροντά μου.
              </>
            ) : (
              <>As a registered user of the Olympus Riviera Greece application, I want to receive suggestions of activities or points of interest based either on the ratings and preferences of users with a similar profile (Collaborative Filtering) or on my own previous preferences and choices (Content-based Filtering), so that I can find suggestions that match my interests.</>
            )}
          </Description>
          <PersonalisedReqs />
          <SimilarReqs />
        </RecomendationsContainer>
      )}

     {(!loggedIn || userRole != "RegisteredUser") && (
       <div style={{margin:"50px"}}>
        <PopularDestinationsHome ></PopularDestinationsHome>
       </div>
      )}


      {/* Floating button */}
      <FloatingBookButton onClick={() => setShowBookingModal(true)}>
        {i18n.t('bookNow')}
      </FloatingBookButton>

      {/* Modal */}
      <UpiriaModal
        spaLink={standardUpiriaLink}
        expTitle={standardExpTitle}
        visible={showBookingModal}   // Pass visible prop
        onClose={() => setShowBookingModal(false)}
      />
    </Container>
  );
};

export default PlanYourTrip;
